import { render, staticRenderFns } from "./shareOrder5.vue?vue&type=template&id=ff792374&scoped=true&"
import script from "./shareOrder5.vue?vue&type=script&lang=js&"
export * from "./shareOrder5.vue?vue&type=script&lang=js&"
import style0 from "./shareOrder5.vue?vue&type=style&index=0&id=ff792374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff792374",
  null
  
)

export default component.exports